

import {TruckCategories} from '../../util/Enum';

export default {
  props: {
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      TruckCategories,
      isModalVisible: false,
      categoriesList: [],
      loading: true,
      selectedCategory: []
    };
  },
  created() {
    this.isModalVisible = this.modalShow;
  },
  mounted() {
    this.loading = true;
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventNav);
  },
  methods: {
    preventNav(event) {
        event.preventDefault()
        event.returnValue = ''
    },
    // Close modal
    close() {
      this.$emit('close');
    },
    // Navigate to create truck
    goToCreateTruck() {
      this.$emit('close');
      this.$router.push({
        path: `/find-transport-carrier/create-truck?category=${encodeURIComponent(this.selectedCategory)}`,
      });  
    },
    // Collect selected categories
    assignSelectedDetails(item) {
      if(item == this.selectedCategory.filter(e => e == item)) {
        const index = this.selectedCategory.indexOf(item)
        if (index > -1) {
          this.selectedCategory.splice(index, 1);
        }
      } else {
        this.selectedCategory.push(item);
      } 
    }
  },
};
